import { BaseResource } from './base-resource';

export class DeliveryCompany extends BaseResource {
  name: string;
  description: string;
  link: string;
}
